import { observer } from 'mobx-react-lite'

import { Stack, Theme } from '@mui/material'
import { TypographyProps } from '@mui/material/Typography'
import { Icon, Text } from '@mxenabled/mxui'
import { CurrencyText } from '../../common/components/CurrencyText'
import { NetWorth } from '../../core/types/NetWorth'

interface NetWorthChangeProps {
  netWorth: NetWorth
  currencyVariant?: TypographyProps['variant']
  currencyLabel?: string
  iconSize?: number
  theme: Theme
}

const NetWorthChange: React.FC<NetWorthChangeProps> = ({
  currencyLabel,
  currencyVariant = 'body2',
  iconSize,
  netWorth,
  theme,
}) => {
  let iconColor = theme.palette.secondary.main
  let currencyTextColor = theme.palette.secondary.main
  let iconName = 'trending_flat'

  if (netWorth.change < 0) {
    iconName = 'trending_down'
  } else if (netWorth.change > 0) {
    iconColor = theme.palette.success.main
    currencyTextColor = theme.palette.success.main
    iconName = 'trending_up'
  }

  return (
    <Stack alignItems="center" direction="row" spacing={4}>
      <Icon
        name={iconName}
        size={iconSize}
        sx={{
          color: iconColor,
        }}
      />
      <CurrencyText amount={netWorth.change} color={currencyTextColor} variant={currencyVariant} />
      <Text variant="body2">{currencyLabel}</Text>
    </Stack>
  )
}

export default observer(NetWorthChange)
